import {Hotel, HotelOfferEntity} from 'modules/sapiSearch/slice'
import {isLastBookedLabelVisible} from 'utils/lastBookedLabel'

import {offersHasPrivateDeal} from '@vio/core/src/offer/business/privateDeals'

enum HotelTrackingTag {
  PriceDrop = 'price_drop',
  MemberDeal = 'member_deal',
  MemberPlusDeal = 'member_plus_deal',
  LastBookedRecently = 'last_booked_recently'
}

enum OfferDisplayedTrackingTag {
  LowestPrice = 'lowest_price',
  Gems = 'gems',
  SignInToUnlock = 'sign_in_to_unlock',
  GreatDeal = 'great_deal'
}

/**
 * Forms an array of 'hotelTags' used for tracking purposes on 'hotelContext'
 * @returns An array of tags
 */
export const listHotelTags = ({
  hotel,
  offerEntity,
  hotelIdsWithGreatDeal,
  shouldSeeOffersUnlocked
}: {
  hotel: Hotel
  offerEntity: HotelOfferEntity
  hotelIdsWithGreatDeal: Set<string>
  shouldSeeOffersUnlocked: boolean
}): HotelTrackingTag[] => {
  const tags = []

  if (hotelIdsWithGreatDeal.has(hotel.objectID))
    tags.push(HotelTrackingTag.PriceDrop)

  if (offersHasPrivateDeal(offerEntity?.offers, shouldSeeOffersUnlocked))
    tags.push(HotelTrackingTag.MemberDeal)

  if (isLastBookedLabelVisible(hotel.lastBooked))
    tags.push(HotelTrackingTag.LastBookedRecently)

  return tags
}

/**
 * Forms an array of 'displayedTags' used for tracking purposes on 'offerContext'
 * @returns An array of tags
 */
export const listDisplayedTagsForOffer = ({
  isCheapestOffer,
  isFirstOfferInList,
  isGreatDeal
}: {
  isCheapestOffer: boolean
  isFirstOfferInList: boolean
  isGreatDeal: boolean
}): OfferDisplayedTrackingTag[] => {
  const tags: OfferDisplayedTrackingTag[] = []

  if (isCheapestOffer && isFirstOfferInList) {
    tags.push(OfferDisplayedTrackingTag.LowestPrice)
  }

  if (isCheapestOffer && isGreatDeal) {
    tags.push(OfferDisplayedTrackingTag.GreatDeal)
  }

  return tags
}
